import { render, staticRenderFns } from "./HintTool.html?vue&type=template&id=98b83f6e&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./HintTool.scss?vue&type=style&index=0&id=98b83f6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b83f6e",
  null
  
)

export default component.exports